"use strict";
import "src/decidim/initiatives/application";
import "src/decidim/initiatives/identity_selector_dialog";
import "src/decidim/initiatives/scoped_type";
require.context("../images", true);
import "stylesheets/initiatives.scss";
